import { InferType } from 'yup'

import { RemoveIndex } from 'src/types/common'

import {
  invoiceAddressSchema,
  treeStepSchema,
  paymentStepSchema
} from './validationSchema'

export type InvoiceAddressValues = RemoveIndex<
  InferType<typeof invoiceAddressSchema>
>
export type DonateFormStepOneValues = RemoveIndex<
  InferType<typeof treeStepSchema>
> & {
  SelectPlantingRegion: boolean
  PostMessage: boolean
}

export interface DonateFormStepTwoValues
  extends Omit<
    RemoveIndex<InferType<typeof paymentStepSchema>>,
    'InvoiceAddress'
  > {
  InvoiceAddress: InvoiceAddressValues
}
export type DonateFormValues = DonateFormStepOneValues & DonateFormStepTwoValues

export enum DonateFrequencyTab {
  Once = 'oneoff',
  Monthly = 'monthly',
  // Annual is the package-flow cadence (annual subscriptions). The legacy
  // donate page's frequency tabs are hardcoded to Once/Monthly, so this value
  // is only ever set via the package flow (`/get-started?donationType=annual`).
  Annual = 'annual'
}
